import { useEffect } from 'react';

interface SEOHeadProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogType?: string;
}

export default function SEOHead({
  title,
  description,
  keywords,
  canonicalUrl,
  ogTitle,
  ogDescription,
  ogType = 'website',
}: SEOHeadProps) {
  useEffect(() => {
    document.title = title;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    if (keywords) setMeta('keywords', keywords);

    if (ogTitle) setMeta('og:title', ogTitle, true);
    else setMeta('og:title', title, true);

    if (ogDescription) setMeta('og:description', ogDescription, true);
    else setMeta('og:description', description, true);

    setMeta('og:type', ogType, true);

    if (canonicalUrl) {
      let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
      if (!link) {
        link = document.createElement('link');
        link.rel = 'canonical';
        document.head.appendChild(link);
      }
      link.href = canonicalUrl;
    }

    setMeta('twitter:card', 'summary_large_image');
    if (ogTitle) setMeta('twitter:title', ogTitle);
    else setMeta('twitter:title', title);
    if (ogDescription) setMeta('twitter:description', ogDescription);
    else setMeta('twitter:description', description);
  }, [title, description, keywords, canonicalUrl, ogTitle, ogDescription, ogType]);

  return null;
}